import useMainStore from '../../store/store';
import IosPWAGuide from '../PWAFeatures/iOSmodal';

const AppModal = () => {
  const showAppModal = useMainStore((s) => s.showAppModal);

  if (showAppModal === 'iosPWA') {
    return <IosPWAGuide />;
  }

  return null;
};

export default AppModal;
